module.exports = __webpack_public_path__ + "img/32204003.15caa815.png";